// Import the functions you need from the SDKs you need
import FIREBASE_CONFIG from "@shared/config/integrations/firebase.config";
import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
import { getMessaging, getToken, isSupported, onMessage } from "firebase/messaging";
// ────────────────────────────────────────────────────────────────────────────────
// VALIDACIONES INICIALES (no explotan, sólo loggean)
// ────────────────────────────────────────────────────────────────────────────────
const hasWindow = typeof window !== "undefined";
const isSecureContextLike =
  hasWindow &&
  (window.isSecureContext ||
    (window.location && (window.location.protocol === "https:" || window.location.hostname === "localhost")));

if (!FIREBASE_CONFIG) {
  console.warn("[FCM] FIREBASE_CONFIG no está definido.");
}

const {
  REACT_APP_AUTH_DOMAIN,
  REACT_APP_API_KEY,
  REACT_APP_PROJECT_ID,
  REACT_APP_STORAGE_BUCKET,
  REACT_APP_MESSAGING_SENDER_ID,
  REACT_APP_ID,
  REACT_APP_MEASUREMENT_ID,
  REACT_APP_VAPID_KEY,
} = FIREBASE_CONFIG || {};

[
  ["REACT_APP_API_KEY", REACT_APP_API_KEY],
  ["REACT_APP_AUTH_DOMAIN", REACT_APP_AUTH_DOMAIN],
  ["REACT_APP_PROJECT_ID", REACT_APP_PROJECT_ID],
  ["REACT_APP_STORAGE_BUCKET", REACT_APP_STORAGE_BUCKET],
  ["REACT_APP_MESSAGING_SENDER_ID", REACT_APP_MESSAGING_SENDER_ID],
  ["REACT_APP_ID", REACT_APP_ID],
].forEach(([k, v]) => {
  if (!v) console.warn(`[FCM] Falta variable de entorno: ${k}`);
});

if (!REACT_APP_VAPID_KEY) {
  console.warn("[FCM] Falta REACT_APP_VAPID_KEY (requerida para getToken).");
}

if (!hasWindow) {
  console.warn("[FCM] 'window' no disponible (¿SSR?). FCM no funcionará en este contexto.");
} else {
  if (!("serviceWorker" in navigator)) {
    console.warn("[FCM] Service Workers no soportados por el navegador.");
  }
  if (!("Notification" in window)) {
    console.warn("[FCM] Notification API no soportada por el navegador.");
  }
  if (!isSecureContextLike) {
    console.warn("[FCM] Contexto no seguro. FCM requiere HTTPS o localhost.");
  }
}

// export const checkIsSupported = async () => await isSupported();
export let isSupport = false;
try {
  isSupport = await isSupported();
} catch (e) {
  console.warn("[FCM] isSupported() falló:", e);
}

const firebaseConfig = {
  apiKey: REACT_APP_API_KEY,
  authDomain: REACT_APP_AUTH_DOMAIN,
  projectId: REACT_APP_PROJECT_ID,
  storageBucket: REACT_APP_STORAGE_BUCKET,
  messagingSenderId: REACT_APP_MESSAGING_SENDER_ID,
  appId: REACT_APP_ID,
  measurementId: REACT_APP_MEASUREMENT_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

let messaging = null;
try {
  const supported = await isSupported().catch(() => false);
  if (supported) {
    messaging = getMessaging(app);
  } else {
    console.warn("[FCM] Browser does not support Firebase Messaging.");
  }
} catch (err) {
  console.error("[FCM] Failed to initialize Firebase Messaging", err);
}

export const getFirebaseToken = async () => {
  try {
    if (!messaging) {
      console.warn("[FCM] messaging no inicializado.");
      return null;
    }
    if (!hasWindow) {
      console.warn("[FCM] window no disponible (¿SSR?).");
      return null;
    }
    if (!isSecureContextLike) {
      console.warn("[FCM] Contexto no seguro (HTTPS/localhost requerido).");
      return null;
    }
    if (!("Notification" in window)) {
      console.warn("[FCM] Notification API no soportada.");
      return null;
    }
    if (Notification.permission === "denied") {
      console.warn("[FCM] Permiso de notificaciones BLOQUEADO por el usuario.");
      return null;
    }
    if (!REACT_APP_VAPID_KEY) {
      console.warn("[FCM] VAPID key ausente. No se puede obtener token.");
      return null;
    }

    return await getToken(messaging, { vapidKey: REACT_APP_VAPID_KEY }).catch((e) => {
      console.error("[FCM] getToken() error:", e);
      return null;
    });
  } catch (err) {
    console.error("[FCM] An error occurred while retrieving Firebase token.", err);
    return null;
  }
};

export const onForegroundMessage = () =>
  new Promise((resolve) => {
    if (!messaging) {
      console.warn("[FCM] onForegroundMessage: messaging no inicializado.");
      resolve(null);
      return;
    }
    try {
      onMessage(messaging, (payload) => {
        resolve(payload);
      });
    } catch (err) {
      console.error("[FCM] onForegroundMessage error:", err);
      resolve(null);
    }
  });

export { messaging };
